<template>
    <div class="bag_main">
        <!-- <div class="bag_title">
            <div class="cz_class">
                <div class="cz_item flex_box">
                    <h4 class="font_color" @click="cz_id = 1" :class="{ 'cz_color': cz_id == 1 }">会员平台充值</h4>
                    
                    <img v-show="cz_id == 1" class="btn_bg" src="/member/img/btn_bg.png">
                </div>
                <div class="cz_item flex_box">
                    <h4 class="font_color" @click="cz_id = 2" :class="{ 'cz_color': cz_id == 2 }">购买月卡</h4>
                    <img v-show="cz_id == 2" class="btn_bg" src="/member/img/btn_bg.png">
                </div>
                <div class="cz_item flex_box" v-if="!userInfo.m_user_mouth">
                    <h4 class="font_color" @click="cz_id = 3" :class="{ 'cz_color': cz_id == 3 }">购买包服卡</h4>
                    <img v-show="cz_id == 3" class="btn_bg" src="/member/img/btn_bg.png">
                </div>
            </div>
            <div class="tip">
                <div class="tip_icon flex_box font_color">?</div>
                <span class="font_color">如遇充值问题，请联系任意平台客服</span>
            </div>
        </div> -->
        <div class="bag_box">
            <div v-show="cz_id == 1">
                <div class="user_bag">
                    <span class="user_title" style="border-left: 4px solid #ff3f3f;">快捷充值</span>
                    <span class="user_title">活动期间享受超高充值倍率</span>
                </div>
                <!-- 广告banner -->
                <div class="cz_ad flex_box" v-if="pc_image">
                    <a @click="toActive"><img class="ad_banner" :src="pc_image" ></a>
                </div>
                <!--  -->
                <div class="bag_content">
                    <div class="content_left">
                        <!-- <div class="tip_box my_mg">
                            <span class="content_title " >充值金额：</span>
                            <span class="content_font">活动期间享受超高充值倍率，<span  class="activity_font">最高倍率35倍</span></span>
                        </div> -->
                        <!-- <div v-if="zqd_on">
                            <span class="content_font"><span  class="activity_font">储值双倍花，游戏毕业后请及时操作转区</span></span><br>
                            <span class="content_font">转区点可在本站使用本系统的任意区服使用!</span><br>
                            <span class="content_font">转区点需要配合对应平台储值，激活使用！</span><br>
                            <span class="content_font">例：您回收500转区点在新服兑换500储值，则激活500转区点，共1000充值额度。</span>
                        </div> -->
                        <div class="row" :style="zqd_on?'background:url('+img_url+'ffd6af71-ebcf-5c37-0a02-2026recharge) 100% no-repeat;background-size: 100% 100%;':'width: 100%;'">
                            <div class="col-4" v-for="(m, index) in feed_list" :key="index">
                                <div class="money" :style="zqd_on && [0, 1, 2].includes(index)?'margin-top:160px':''" :class="{ 'money_active':isMoney === index }" ref="my" @click="hitMoney(index,m.value)"  :value="m.value" :real_value="m.real_value">
                                    <div class="card_content">
                                        <!-- <img v-if="zqd_on" class="zqdjb" src="/WalletRecharge/img/zqd.png"> -->
                                        <span class="card_title">可获得额度</span>
                                        <h5 class="host_num">￥{{ Math.ceil(m.value_sum) }}</h5>
                                        <span v-if="zqd_on" style="font-size: 12px;font-weight: 1000;">转区点 ￥{{ Math.ceil(m.transfer) }}</span>
                                        <div class="flex_box new_spade_money" v-if="m.show_value == 1">
                                            <div class="old_price">
                                                <div class="huaheng"></div>
                                                <span class="old_price_num">原价:{{ Math.ceil(m.value)}}</span>
                                            </div>
                                            <span class="new_price_num">优惠价:{{ m.real_value }}</span>
                                            <img class="xsth" src="/WalletRecharge/img/xsth.png">
                                        </div>
                                        <span v-else class=" money_size">支付{{ Math.ceil(m.value) }}元</span>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-4">
                                <div class="money" :class="{ 'money_active':isFocused || isMoney == 99 }" ref="my" @click.stop="focusInput">
                                    <div class="card_content">
                                        <span class="card_title">可获得额度</span>
                                        <h5 class="host_num">{{ Math.ceil(receiptNum) }}</h5>
                                        <input autocomplete="new-password" class=" money_size form_qita" maxlength="4"
                                            oninput="value=value.replace(/[^\d]/g,'')" ref="custom_money" type="text"
                                            v-model.number="ref_money" placeholder="请输入充值金额（大于或等于100）" v-on:focus="isFocused = true"
                                            v-on:blur="isFocused = false; isMoney = 99" @focus="ref_focus()" @click.stop>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="my_mg qq">
                            <label class="content_title mb-3">到账信息：</label>
                            <div class="money_info">
                                <span class=" recharge_font lv_m">到账额度:<span class="number_color">{{ receipt_data.remaining_money || 0}}</span></span>
                                <span v-if="!zqd_on" class=" recharge_font lv_m">充值倍数：<span class="number_color"><b>{{ receipt_data.multiple || 0}}</b></span></span>
                                <span v-else class=" recharge_font lv_m">活动赠送：<span class="number_color"><b>{{ receipt_data.give_money || 0}}</b></span></span>
                                <span v-if="!zqd_on" class=" recharge_font lv_m">赠送积分：<span class="number_color">{{receipt_data.give_money || 0}}</span></span>
                                <span v-else class=" recharge_font lv_m">赠送转区点：<span class="number_color">{{receipt_data.transfer || 0}}</span></span>
                                <div class="lv_send">
                                    <span v-if="!zqd_on" class="recharge_font lv_m">充值后等级：<span class="number_color">{{ receipt_data.vip || '-'}}</span></span>
                                    <span v-else class="recharge_font lv_m">总倍数：<span class="number_color">{{ receipt_data.multiple || '-'}}</span></span>
                                </div>
                            </div>
                        </div>
                        <span class="user_title_middle">您当前等级为 <b style="color: rgb(255, 160, 0);">VIP{{userInfo.user_growth || 0}}</b> 兑换游戏加成 <b style="color:red">{{userInfo.exchange_jiacheng || 0}}%</b> ,继续充值 <b style="color:red">{{userInfo.vip_experience || 0}}元</b> 等级提升至 <b style="color: rgb(255, 160, 0);">VIP{{ userInfo.next_level || 0 }}</b> 享受更高兑换加成！</span>
                        <div class="payment">
                            <span class="content_title">支付信息：<a style="font-size: 12px;font-weight: 1000;color: rgb(223, 6, 0);">提示：您额外支付的风控金为第三方支付收取，本站已经在您充值成功后额外赠送50储值点！</a></span>
                            <div class="pay_box mt-3">
                                <span class="pay_box_text">支付方式</span>
                                <a class="pay_type_btn flex_box"
                                    :class="{ 'active_pay': isMethod === p.value }" @click="isMethod = p.value"
                                    v-for="p in pay_list" :key="p.value">
                                    <img style="width: 100%; height: 31.7px;" :src="p.image">
                                    <!-- {{ p.label }} -->
                                </a>
                            </div>
                        </div>
                        <div class="flex_box" style="width: 100%;">
                            <a  class="oder_btn btn_hover my_mg" @click="pay()">立即提交</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-show="cz_id == 2">
                <div class="">
                    <div class="card_box" v-if="!userInfo.m_user_card">
                        <span class="content_left_font ">月卡:</span>
                        <div class="card_item mt-2">
                            <div class="row">
                                <div class="col-3" v-for="card in card_data" :key="card.id"
                                    @click="is_card = card.id; selectCard(card)">
                                    <div class="card_index">
                                        <img class="card_img" v-if="is_card == card.id" :src="img_url + card.card_img_fan"
                                            width="100%">
                                        <img class="card_img" v-else :src="img_url + card.card_img" width="100%">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="my_card" v-else>
                        <div class="flex_box">
                            <span class="content_left_font ">月卡奖励</span>
                            <span class="become_time">有效期至：{{ become_time }}</span>
                        </div>
                        <div class="my_card_box">
                            <img class="my_card_img" v-lazy="img_url + ueser_cards.card_img" >
                            <div class=" ykfl_box">
                                <div class="ykfl_content">
                                    <div class="ykfl_title">
                                        <h4>月卡福利</h4>
                                        <span>MONTHLY CARD</span>
                                    </div>
                                    <div class="yk_num">
                                        <span class="yk_tip">{{ my_day_receive }}</span>
                                        <img class="ds_bg" src="/WalletRecharge/img/ds.png">
                                    </div>
                                    <div class="yk_title">每日可领取月卡点</div>
                                    <div class="yk_sm">
                                        <span>月卡规则：</span>
                                        <span class="suoming">·月卡购买后，持续{{my_card_time}}天享受月卡权益，须到期才可以更改月卡档位。每张月卡所对应的奖励不同.</span>
                                    </div>
                                </div>
                                <img class="people" src="/WalletRecharge/img/people.png">
                                <img class="yk_bg" src="/WalletRecharge/img/ykfl.png">
                            </div>

                        </div>
                    </div>

                    <div class="payment" v-if="!userInfo.m_user_card">
                        <span class="content_left_font">支付方式：</span>
                        <div class="flex_box mt-2">
                            <a class="method content_left_font pay_hover flex_box"
                                :class="{ 'hit_pay': isMethod === p.value }" @click="isMethod = p.value"
                                v-for="p in pay_list" :key="p.value">
                                <img :src="p.image" class="method_img">
                                {{ p.label }}
                                <img class="qr" :class="{ 'btn_active': isMethod === p.value }"
                                    src="/WalletRecharge/img/gou2.png">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="money_unifo" v-if="!userInfo.m_user_card">
                    <span class=" content_left_font my_mg lv_m">月卡售价：<span class="number_color">{{ card_price
                    }}</span>元</span>
                    <span class=" content_left_font my_mg lv_m">每日可领取月卡点：<span class="number_color">{{ day_receive
                    }}</span></span>
                    <div class="lv_send my_mg">
                        <span class="content_left_font lv_m">月卡有效期：<span class="number_color">{{ expires_time
                        }}</span>天</span>
                    </div>
                </div>
                <div class="money_unifo">
                    <a v-if="!userInfo.m_user_card" class="submit_btn btn_color btn_font my_mg" @click="cardPay()">立即提交</a>
                    <a v-else-if="is_sigin" class="lq_btn btn_color btn_font my_mg" @click="SignIn">立即领取</a>
                    <a v-else class="lq_btn btn_font my_mg isClick">已领取</a>
                </div>
            </div> -->
            <div v-show="cz_id == 3" v-if="!userInfo.m_user_mouth">
                <div class="">
                    <div class="card_box" >
                        <span class="content_left_font ">包服卡:</span>
                        <div class="card_item mt-2">
                            <div class="row">
                                <div class="col-3" v-for="card in mouth_data" :key="card.id"
                                    @click="is_card = card.id; mouth_price = card.price">
                                    <div class="card_index">
                                        <img class="card_img" v-if="is_card == card.id" :src="card.card_img_fan"
                                            width="100%">
                                        <img class="card_img" v-else :src="card.card_img" width="100%">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="payment" v-if="!userInfo.m_user_card">
                        <span class="content_left_font">支付方式：</span>
                        <div class="flex_box mt-2">
                            <a class="method content_left_font pay_hover flex_box"
                                :class="{ 'hit_pay': isMethod === p.value }" @click="isMethod = p.value"
                                v-for="p in pay_list" :key="p.value">
                                <img :src="p.image" class="method_img">
                                {{ p.label }}
                                <img class="qr" :class="{ 'btn_active': isMethod === p.value }"
                                    src="/WalletRecharge/img/gou2.png">
                            </a>
                        </div>
                    </div>
                </div>
                <div class="money_unifo" v-if="!userInfo.m_user_card">
                    <span class=" content_left_font my_mg lv_m">包服卡售价：<span class="number_color">{{ mouth_price
                    }}</span>元</span>
                </div>
                <div class="flex_box">
                    <span class="font_must">需在会员有效期内可使用包服卡兑换</span>
                </div>
                <div class="money_unifo">
                    <a v-if="!userInfo.m_user_card" class="submit_btn btn_color btn_font my_mg" @click="mouthPay()">立即提交</a>
                </div>
            </div>
            <Login ref="login"></Login>
        </div>
        <!-- 活动悬浮窗 -->
        <ShowSuspension></ShowSuspension>
        <!-- <ActiveSuspension  v-if="material.pc_index_alert ? material.pc_index_alert.img : false"></ActiveSuspension> -->
        <!-- 充值活动倒计时悬浮窗 -->
        <!-- <div class="djs_float">
            <div class="djs_box">
                <span class="djs_time">{{ countdown_hours }}<span style="color: red;">:</span>{{ countdown_minutes }}</span>
                <img class="djs_img" src="/banner/img/djs.png" >
            </div>
        </div> -->
    </div>
</template>
  
<script>
import { auto } from "@popperjs/core";
import layer from "layui-layer";
import Login from '../components/Login.vue'
import ActiveSuspension from '../components/ActiveSuspension.vue'
import ShowSuspension from '../components/ShowSuspension.vue'
import { getPaymentAvailableList, initiatePayment, verifyOrderStatus, getCardList, createCardCharge, getUserCard,toCardSigin,getCardSigin,selectMyUserCard,getRechargeAmount,getMouthList,createMouthCharge,rechargeCount,rechargeNoLoginCount } from '@/api/http.js'
import { mapState } from 'vuex';
export default {
    name: 'WalletRecharge',
    components: { Login,ActiveSuspension,ShowSuspension },
    data() {
        return {
            zqd_on: false, //转区点赠送角标显隐开关
            feed_list: '', //充值项数组
            pay_list: '',    //支付方式项
            isMoney: '', //选择状态
            ref_money: '', //自定义金额
            real_value:0,//实际金额
            moneyValue: 0, //充值金额
            lvNum: 0, //储值加送
            addSendNum: 0, //等级加送
            isMethod: 2,    //支付选择
            contact: '', //联系方式
            max_price: '',   //最大充值金额
            min_price: '',    //最小充值金额
            times: 1, //倍数
            bool: true, //判断发起订单请求（防止连续发起）
            timer: '',
            activity_timer:null, //充值活动倒计时
            countdown_hours: '24',
            countdown_minutes:'00',
            totalSeconds: 0,
            pc_image: false, //充值界面banner
            pc_jump_url: '',
            tab: '_self',
            isFocused: false,
            card_data: [], //卡牌列表
            mouth_data: [], //包服卡列表
            is_card: '', //卡牌选择
            card_price: 0, //卡牌售价
            mouth_price:0, //包服卡售价
            day_receive: 0, //每日可领取积分
            expires_time: 0, //有效期
            card_id: '',//当前选择的卡包ID
            czc_type: '', //如果为1时表示当前订单为平台充值，为2表示当前订单为月卡
            ueser_cards: [], //用户月卡信息
            become_time: '', //用户当前月卡到期时间
            my_day_receive:0, //当前拥有月卡每日可领取
            flag: true,//签到按钮点击状态
            is_sigin: '',//是否可以签到
            my_card_time:0, //当前拥有月卡天数
            my_card_open:'', //用户是否有月卡
            amount_timer:'',//获取实际金额请求定时器
            receipt_data:{},//到账信息
        }
    },
    watch: {
        ref_money: {
            // immediate: true, // 立即执行
            deep: true,
            handler(nval, oval) {
                if (nval) {
                    this.isMoney = ''
                    this.real_value = 0
                    this.moneyValue = this.ref_money
                    clearTimeout(this.amount_timer); // 清除上一个定时器
                    this.amount_timer = setTimeout(() => {
                        this.rechargeCount(nval)
                    }, 1000); 
                } else {
                    this.moneyValue = 0
                }
                // 当input框有值，又去选中其他金额，让充值金额变为选中的金额
                if (this.isMoney) {

                    if (this.$refs.my[this.isMoney]) {
                        this.moneyValue = this.$refs.my[this.isMoney].getAttribute('value')
                    }
                }
                else if (this.isMoney == 0) {
                    if (this.$refs.my[this.isMoney]) {
                        this.moneyValue = this.$refs.my[this.isMoney].getAttribute('value')
                    }
                }
                // console.log(oval + '变为' + nval)
                this.feed_list.some((item, index) => {
                    if (nval * 1 < item.value) {
                        let ab = this.feed_list[index - 1] ? this.feed_list[index - 1].percentage : this.feed_list[index].percentage
                        this.lvNum = nval * 1 * ab * this.times
                        return true
                    } else if (nval * 1 >= this.feed_list[this.feed_list.length - 1].value) {
                        this.lvNum = nval * 1 * this.feed_list[this.feed_list.length - 1].percentage * this.times
                    }
                })
            }
        },
        lvNum: {
            immediate: true, // 立即执行
            deep: true,
            handler(nval, oval) {
                this.lvNum = Number(nval).toFixed(2)
            }
        },
        isMoney: {
            deep: true,
            handler(nval, oval) {
                if (nval && nval != 99) {
                    this.lvNum = this.cfa(this.moneyValue, this.feed_list[nval].percentage)
                }
            }
        }

    },
    computed: {
        ...mapState([
            'getClient',
            'userInfo',
            'material'
        ]),
        sigin_eg: {
            get() {
                return this.$store.state.sigin_eg
            },
            set(val) {
                return this.$store.state.sigin_eg = val
            }
        },
        cz_id: {
            get() {
                return this.$store.state.cz_id
            },
            set(val) {
                return this.$store.state.cz_id = val
            }
        },
        lvNumShow() {
            var val = Math.ceil(this.receiptNum) - Math.ceil(this.moneyValue * this.times)
            return val
        },
        receiptNum: {
            get() {
                var result = (eval((this.moneyValue * 1)) * this.times + this.lvNum * 1)
                return Number(result).toFixed(2)
            },
            set(val) {
                return val
            }

        },
        pay_ewm: {
            get() {
                return this.$store.state.pay_ewm
            },
            set(val) {
                return this.$store.state.pay_ewm = val
            }
        },
        pay_money: {
            get() {
                return this.$store.state.pay_money
            },
            set(val) {
                return this.$store.state.pay_money = val
            }
        },
        pay_type: {
            get() {
                return this.$store.state.pay_type
            },
            set(val) {
                return this.$store.state.pay_type = val
            }
        },
        orderID: {
            get() {
                return this.$store.state.orderID
            },
            set(val) {
                return this.$store.state.orderID = val
            }
        },
    },
    methods: {
        // 充值活动倒计时
        startCountdown() {
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            this.totalSeconds = (24 - hours) * 3600 - minutes * 60; // 计算到00:00的总秒数

            this.updateCountdown();
            this.activity_timer = setInterval(() => {
                this.totalSeconds--;
                if (this.totalSeconds < 0) {
                    this.totalSeconds = 24 * 3600; // 重置为24:00
                    location.reload()
                }
                this.updateCountdown();
            }, 1000);
        },
        updateCountdown() {
            const hours = Math.floor(this.totalSeconds / 3600);
            const minutes = Math.floor((this.totalSeconds % 3600) / 60);
            const seconds = this.totalSeconds % 60;
            this.countdown_hours = `${String(hours).padStart(2, '0')}`
            this.countdown_minutes = `${String(minutes).padStart(2, '0')}`;
        },
         // 获取包服卡列表接口
         getMouthList(){
            getMouthList().then((res)=>{
                if(res.code == 200){
                    this.mouth_data = res.data
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                });
            })
        },
        //获取实际充值金额接口
        getRechargeAmount(){
            getRechargeAmount({
                money:this.ref_money
            }).then((res)=>{
                if(res.code == 200){
                    this.real_value = res.data.real_money
                    this.times = res.data.magnification
                }
            }).catch((err)=>{
                console.log("捕获异常", err)
            })
        },
        // 查询用户是否有月卡
        selectMyUserCard(){
            selectMyUserCard().then((res)=>{
                if(res.code == 200){
                    this.my_card_open = res.msg
                    if(res.msg){
                        this.getCardSigin()
                        this.getUserCard()
                    }
                }
            }).catch((err)=>{
                console.log("捕获异常", err)
            })
        },
        //签到状态查询接口
        getCardSigin() {
            getCardSigin().then((res) => {
                if (res.code === 200) {
                    console.log(res)
                    this.is_sigin = res.data.is_sigin
                }
            }).catch((err) => {
                console.log("捕获异常", err)
            })
        },
        // 获取签到奖励MSG接口
        toCardSigin() {
            toCardSigin().then((res) => {
                if (res.code === 200) {
                    this.sigin_eg = res.msg
                    console.log(res);
                    this.tcSigin()
                }
            }).catch((err) => {
                console.log("捕获异常", err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500,
                    onClose: () => {
                        this.flag = true
                    }
                })
            })
        },
        toPayCard(){
            this.cz_id = 2
            this.$router.push({
                path:'/member/wallet'
            })
        },
        // 弹窗方法
        tcSigin() {
            var that = this
            var sign_tc = $('.sign_tc')
            var LayIndex = layer.open({
                type: 1,
                content: sign_tc,
                anim: false,
                fixed: true,
                shade: 0.6,
                title: 0,
                scrollbar: true,
                shadeClose: false,
                closeBtn: 0,
                isOutAnim: false,
                area: [auto, auto],
                success: function (layero) {
                    const lq = $(layero).find('.sign_btn');
                    lq.click(function () {
                        layer.close(LayIndex)
                        location.reload()
                        // that.getUserSigin()
                    })
                }
            });
        },
        SignIn() {
            if (this.userInfo.day_card_integral) {
                if (this.flag && this.is_sigin == true) {
                    this.flag = false
                    this.toCardSigin()
                } else {
                    this.flag = false
                    if (this.is_sigin == false) {
                        this.$message({
                            message: '今日已经领取！',
                            type: 'warning',
                            duration: 1500,
                            onClose: () => {
                                this.flag = true
                            }
                        })
                    } else {
                        this.$message({
                            message: '请勿重复提交，请稍后再试~',
                            type: 'warning',
                            duration: 1500,
                            onClose: () => {
                                this.flag = true
                            }
                        })
                    }

                }
            }else{
                this.$confirm('当前账号未购买月卡或月卡已过期，是否跳转至月卡购买页面！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.toPayCard()
                }).catch(() => {
                });
            }

        },
        // 获取用户卡牌信息接口
        getUserCard() {
            getUserCard().then((res) => {
                if (res.code == 200) {
                    this.become_time = res.data[0].expires_time
                    this.ueser_cards = res.data[0].data
                    this.my_day_receive = res.data[0].data.day_receive
                    this.my_card_time = res.data[0].data.expires_time
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                });
            })
        },
        // 选择卡包
        selectCard(card) {
            this.card_price = Number(card.price).toFixed(0)
            this.day_receive = card.day_receive
            this.expires_time = card.expires_time
            this.card_id = card.id
        },
        // 月卡列表接口
        getCardList() {
            getCardList().then((res) => {
                if (res.code == 200) {
                    this.card_data = res.data
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                });
            })
        },
        focusInput() {
            this.$refs.custom_money.focus();
        },
        //直接点击输入框初始化
        ref_focus(){
            this.isMoney = 99
            this.times = 1
            this.moneyValue = 0
            this.lvNum = 0
            this.receiptNum = 0
            this.ref_money = ''
            this.real_value = 0
        },
        toActive() {
            if (this.pc_jump_url) {
                if (localStorage.getItem('token')) {
                    this.funRouter()
                } else {
                    this.$refs.login.open()
                }
            }
            this.$czc('pc充值页面横幅', '点击', '访问活动页面')
            // this.$czc('测试埋点', '点击', '访问')
        },
        funRouter() {
            var routeUrl = this.$router.resolve({
                path: this.pc_jump_url,
            })
            window.open(this.pc_jump_url.includes('http') ? this.url : routeUrl.href, '_blank');
        }, 
        hitMoney(index,money) {
            this.isMoney = index
            this.times = this.feed_list[index].times
            // console.log(index)
            this.ref_money = ''
            this.real_value = this.$refs.my[this.isMoney].getAttribute('real_value')
            this.moneyValue = this.$refs.my[index].getAttribute('value')  //获取上面选择的元素的value属性值
            this.lvNum = this.cfa(this.moneyValue, this.feed_list[index].percentage)

            this.rechargeCount(money)
        },
        rechargeCount(val){
            if(!this.userInfo.id>0){
                rechargeNoLoginCount({
                    money:val
                }).then((res) =>{
                    if(res.code == 200){
                        this.receipt_data = res.data
                    }
                }).catch((err) =>{
                    console.log('捕获异常', err)
                    this.$message({
                        message: err.msg,
                        type: 'warning',
                        duration: 1500
                    });
                })
            }else{
                rechargeCount({
                    money:val
                }).then((res) =>{
                    if(res.code == 200){
                        this.receipt_data = res.data
                    }
                }).catch((err) =>{
                    console.log('捕获异常', err)
                    this.$message({
                        message: err.msg,
                        type: 'warning',
                        duration: 1500
                    });
                })
            }
        },
        cfa(arg1, arg2) {
            var m = 0;
            var s1 = arg1.toString();
            var s2 = arg2.toString();
            try {
                m += s1.split(".")[1].length;
            } catch (e) { }
            try {
                m += s2.split(".")[1].length;
            } catch (e) { }

            return Number(s1.replace(".", "")) * Number(s2.replace(".", "") * this.times) / Math.pow(10, m);
        },
        // 获取支付可用列表
        getPaymentAvailableList() {
            getPaymentAvailableList().then((res) => {
                if (res.code === 200) {
                    this.feed_list = res.data.feed_list
                    this.pay_list = res.data.pay_list
                    this.zqd_on = res.data.hd_switch
                    this.max_price = Number(res.data.max_price).toFixed(0)
                    this.min_price = Number(res.data.min_price).toFixed(0)
                    // this.times = res.data.times
                    this.pc_image = res.data.pc_image
                    this.pc_jump_url = res.data.pc_jump_url
                }
            }).catch((err) => {
                console.log('捕获异常', err)
            })
        },
        // 月卡支付接口
        createCardCharge() {
            createCardCharge({
                card_id: this.card_id,
                pay_type: this.isMethod,
            }).then((res) => {
                if (res.code === 200) {
                    this.pay_ewm = res.data.pay_url
                    this.pay_money = Number(res.data.money).toFixed(0)
                    this.pay_type = res.data.pay_type_msg
                    this.orderID = res.data.out_trade_no
                    this.$czc('PC购买月卡页面-发起订单', '点击', '生成月卡订单')
                    this.czc_type = 2
                    this.payCode()
                    this.bool = true
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                });
                this.bool = true
            })
        },
        // 包服卡支付接口
        createMouthCharge() {
            createMouthCharge({
                money: this.mouth_price,
                pay_type: this.isMethod,
            }).then((res) => {
                if (res.code === 200) {
                    this.pay_ewm = res.data.pay_url
                    this.pay_money = Number(res.data.money).toFixed(0)
                    this.pay_type = res.data.pay_type_msg
                    this.orderID = res.data.out_trade_no
                    this.$czc('PC购买包服卡页面-发起订单', '点击', '生成包服卡订单')
                    this.czc_type = 4
                    this.payCode()
                    this.bool = true
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                });
                this.bool = true
            })
        },
        //发起支付接口
        initiatePayment() {
            initiatePayment({
                money: this.moneyValue,
                contact: this.contact,
                pay_type: this.isMethod,

            }).then((res) => {
                if (res.code === 200) {
                    this.pay_ewm = res.data.pay_url
                    this.pay_money = Number(res.data.money).toFixed(0)
                    this.pay_type = res.data.pay_type_msg
                    this.orderID = res.data.out_trade_no
                    this.$czc('PC充值页面-发起订单', '点击', '生成充值订单')
                    this.czc_type = 1
                    this.payCode()
                    this.bool = true
                }
            }).catch((err) => {
                console.log('捕获异常', err)
                this.$message({
                    message: err.msg,
                    type: 'warning',
                    duration: 1500
                });
                this.bool = true
            })
            // this.bool = true
        },
        // 月卡立即支付
        cardPay() {
            if (localStorage.getItem('token')) {
                if (this.userInfo.user_idcard) {
                    if (this.bool) {
                        this.bool = false
                        this.$message({
                            message: "订单生成中，请稍后···",
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.createCardCharge()
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: "您还未实名，请先实名后使用该功能！",
                        type: 'warning',
                        duration: 1500,
                        onClose: () => {
                            this.$router.push({
                                path: '/member/realName'
                            })
                        }
                    })
                }
            } else {
                this.$message({
                    message: "您还未登录，请先登录！",
                    type: 'warning',
                    duration: 2000,
                    onClose: () => {
                        this.$refs.login.open()
                    }
                });
            }
        },
        //包服卡立即支付
        mouthPay() {
            if (localStorage.getItem('token')) {
                if (this.userInfo.user_idcard) {
                    if (this.bool) {
                        this.bool = false
                        this.$message({
                            message: "订单生成中，请稍后···",
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.createMouthCharge()
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: "您还未实名，请先实名后使用该功能！",
                        type: 'warning',
                        duration: 1500,
                        onClose: () => {
                            this.$router.push({
                                path: '/member/realName'
                            })
                        }
                    })
                }
            } else {
                this.$message({
                    message: "您还未登录，请先登录！",
                    type: 'warning',
                    duration: 2000,
                    onClose: () => {
                        this.$refs.login.open()
                    }
                });
            }
        },
        //立即支付
        pay() {
            if (localStorage.getItem('token')) {
                // if (this.userInfo.user_idcard) {
                    if (this.bool) {
                        if (this.moneyValue * 1 >= this.min_price * 1 && this.moneyValue * 1 <= this.max_price * 1) {
                            this.bool = false
                            this.$message({
                                message: "订单生成中，请稍后···",
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.initiatePayment()
                                }
                            })
                        } else {
                            if (this.moneyValue * 1 < this.min_price * 1) {
                                this.$message({
                                    message: "充值金额小于最低限额",
                                    type: 'warning',
                                    duration: 1500
                                });
                            } else {
                                this.$message({
                                    message: "充值金额超限",
                                    type: 'warning',
                                    duration: 1500
                                });
                            }

                        }
                    }
                // } else {
                //     this.$message({
                //         message: "您还未实名，请先实名后使用该功能！",
                //         type: 'warning',
                //         duration: 1500,
                //         onClose: () => {
                //             this.$router.push({
                //                 path: '/member/realName'
                //             })
                //         }
                //     })
                // }
            } else {
                this.$message({
                    message: "您还未登录，请先登录！",
                    type: 'warning',
                    duration: 2000,
                    onClose: () => {
                        this.$refs.login.open()
                    }
                });
            }


        },
        // 支付二维码弹窗
        payCode() {
            var that = this
            var pay_tc = $('.pay_tc')
            var LayIndex = layer.open({
                type: 1,
                content: pay_tc,
                anim: false,
                fixed: true,
                shade: 0.6,
                title: 0,
                scrollbar: true,
                shadeClose: false,
                isOutAnim: false,
                area: [auto, auto],
                success: function () {
                    // console.log(that)
                    that.timer = setInterval(() => {
                        setTimeout(that.verifyOrderStatus(), 0)
                        if ($(".pay_tc").is(':hidden')) {
                            //处理业务  
                            clearInterval(that.timer)
                        }
                    }, 2000)
                },
            });
        },
        // 订单状态轮巡接口
        verifyOrderStatus() {
            verifyOrderStatus({
                out_trade_no: this.orderID
            }).then((res) => {
                if (res.code === 200) {
                    clearInterval(this.timer)
                    this.timer = ''
                    if (this.czc_type == 1) {
                        this.$czc('PC充值页面-支付二维码弹窗', '扫码', '订单支付成功')
                    }
                    else if (this.czc_type == 2) {
                        this.$czc('PC月卡页面-支付二维码弹窗', '扫码', '订单支付成功')
                    }
                    else if (this.czc_type == 4) {
                        this.$czc('PC包服卡页面-支付二维码弹窗', '扫码', '订单支付成功')
                    }
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.getUserCard()
                            location.reload()
                        },
                    })
                }
            }).catch((err) => {
                console.log('捕获异常', err)

            })
        },
    },
    created() {
        // this.startCountdown() //充值活动倒计时
        if(localStorage.getItem('token')){
            this.selectMyUserCard()
        }
        this.getCardList() //获取卡牌列表
        this.getPaymentAvailableList()
        this.getMouthList() // 获取包服卡列表
        // 判断shif
        if (this.pc_jump_url) {
            this.tab = '_blank'
        }
    },
    mounted(){
       
    },
    beforeDestroy() {
        clearInterval(this.activity_timer); // 清理定时器
    },
}
</script>
  
<style scoped>
/* 同步3PK新增修改 */
.user_bag{
    display: flex;
    align-items: center;
}
.user_title{
    padding-left: 8px;
    font-weight: 600;
    font-size: 16px;
    margin-right: 5px;
}
.user_title_small{
    font-size: 13px;    
    font-weight: 100;
}

.user_title_middle{
    font-size: 15px;    
    font-weight: 100;
    margin-top: 10px;
}

.user_title_tip{
    font-size: 12px;
    color: #999;
}
.content_title{
    font-size: 16px;
    font-weight: 700;
    border-left: 3px solid #ff3f3f;
    padding-left: 5px;
    height: 16px;
    display: flex;
    align-items: center;
}
/*  */
.djs_box{
    position: relative;
}
.djs_time{
    position: absolute;
    left:50%;
    transform: translateX(-50%);
    bottom: 10%;
    color: rgb(73, 0, 125);
    font-size: 32px;
    font-weight: bolder;
    width: 100%;
    text-align: center;
}
.djs_float{
    position: fixed;
    bottom: 20%;
    right: 1%;
    z-index: 99;
}
.djs_img{
    width: 10rem;
}
.activity_font{
    color: red;
    font-size: 18px;
    font-weight: bold;
    font-family: Microsoft YaHei;
}
.content_font{
    font-size: 12px;
    color: #000;
    font-weight: 400;
}
.tip_box{
    display: flex;
    align-items: center;
}
/* 公共 */
.ad_banner{
    width: 600px;
    height: 250px;
}
.bag_main{
    height: 100%;
    position: relative;
}
.isClick {
    background: #AC8747;
    filter: grayscale(100%);
}
.my_mg {
    margin-top: 35px;
}

/* labe字样 */
.content_left_font {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #4D4D4D;
    text-decoration: none;
    margin-bottom: 0;
}
.recharge_font{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4D4D4D;
    text-decoration: none;
    margin-bottom: 0;
}

/* 数字color */
.number_color {
    color: #CF1F1F;
}

.become_time {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #666666;
    margin-left: 10px;
}

/* 选项卡点击 */
.btn_active {
    display: block !important;
}

/*  */
.bag_content {
    width: 100%;
    height: 100%;
}

.cz_color {
    color: #FFFFFF !important;
    background: none !important;
    -webkit-text-fill-color: #FFFFFF !important;
    position: absolute !important;
}

.font_color {
    position: relative;
    z-index: 10;
    color: #A36F28;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    background: linear-gradient(0deg, #A36F28 0%, #C98B36 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    cursor: pointer;
}
.font_must{
    color: red;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 10px;
}

.bag_box {
    padding: 30px 40px 85px;
    background: #FFFFFF;
    border-radius: 0 0 4px 4px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

.bag_title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(178, 147, 96, 0.2);
    background: linear-gradient(0deg, #F6F0E9, #FFFFFF);
    border-radius: 4px 4px 0px 0px;
    padding: 12px 12px 0;
    position: absolute;
}

.fgx {
    width: 1px;
    height: 16px;
    background: #B2B2B2;
    margin: 0 15px;
}

.cz_class {
    display: flex;
    align-items: center;
    justify-content: start;
}

.cz_item {
    position: relative;
    margin-right: 18px;
}

.btn_bg {
    position: relative;
    top: 0;
    left: 0;
    z-index: 1;
    width: 158px;
}

.cz_class h4 {
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin: 0;
}

.tip {
    display: flex;
    align-items: center;
    justify-content: end;
}

.tip_icon {
    width: 13px;
    height: 13px;
    border: 1px solid #806437;
    border-radius: 50%;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-right: 5px;
}

.tip span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
}

.content_left {
    display: flex;
    flex-direction: column;
    align-items: start;
    /* justify-content: space-between; */
    height: 100%;
    margin-top: 10px;
}

.money_items {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    width: 100%;
}

.money_font {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4E4E4E;
    text-align: center;
    text-decoration: none;
}

.jb_box {
    position: absolute;
    right: 0;
    top: -1%;
    z-index: 10;
}

.jb_box span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFBD9;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10;
    left: 78%;
    top: 61%;
    transform: translate(-50%, -50%);
}

.jb_bg {
    position: relative;
    left: 0;
    top: 0;
    text-align: center;
    width: 82px;
}

.money {
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
    transition: all 0.5s;
    cursor: pointer;
    width: 100%;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    padding: 20px 20px 15px;
}

.money:nth-last-child(2) {
    margin-right: 0;
}
.money_active{
    color: #000 !important;
    background-color: #FFF4F4 !important;
    border-color: rgb(223, 6, 0) !important;
}

.zqdjb {
    width: 75px;
    position: absolute;
    right: 0;
    top: -1%;
    z-index: 10;
}

.card_bg {
    position: relative;
    top: 0;
    left: 0;
    width: 220px;
}

.card_content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
}

.card_title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #312B26;
}

.host_num {
    font-size: 28px;
    font-weight: 700;
    color: rgb(223, 6, 0);
}

.host_num span {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #744200;
}

.send_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #A8957A;
    margin-bottom: 10px;
}
.old_price{
    position: relative;
    margin-right: 20px;
}
.huaheng{
    width: 110%;
    height: 2px;
    background: #cccccc;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
}
.old_price_num{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #cccccc;
}
.new_price_num{
     font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: green;
}
.new_spade_money{
    background: rgb(245, 213, 172, 0.7);
    border-radius: 4px;
    padding: 5px 10px;
    position: relative;
}
.xsth{
    position: absolute;
    top: -12px;
    right: -5px;
}
.spade_money {
    background: rgb(245, 213, 172, 0.7);
    border-radius: 4px;
    padding: 5px 30px;
}

.money_size {
    font-size: 15px;
    font-weight: 700;
    color: #666;
    height: 31px;
}

.qr {
    display: none;
    position: absolute;
    right: -1%;
    bottom: 0;
    z-index: 10;
}

.qita_box {
    display: flex;
    margin-top: 10px;
}

.money_qita {
    height: 46px;
    border: 1px solid #4D4D4D;
    border-right: none;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    display: flex;
    padding: 0 10px;
    align-items: center;
}

.qita_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4D4D4D;
}

.form_qita {
    background-color: #FFFFFF;
    background-image: none;
    border: 1px solid #e5e6e7;
    border-radius: 1px;
    color: inherit;
    display: block;
    padding: 6px 12px;
    transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
    width: 100%;
    height: 31px;
    font-size: 0.9rem;
    font-weight: 400;
}

.money_info{
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    border-radius: 5px;
    border: 1px solid rgb(223, 6, 0);
    padding: 15px;
}

.money_unifo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.lv_send {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.receipt {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.lv_m {
    margin-right: 30px;
}

.lv_m:nth-last-child(0) {
    margin-right: 0;
}

.add_send h4 {
    margin-left: 10px;
}

.lv_hop {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A7436;
    text-decoration: none;
    margin-left: 10px;
}

.qq {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    margin-top: 30px;
    width: 100%;
}

.qq_input {
    width: 200px;
    height: 50px;
    background: rgba(246, 242, 235, 0);
    border: 2px solid #4D4D4D;
    border-radius: 4px;
    outline-style: none;
}

.qq_input:focus {
    background: rgba(245, 243, 240, 0) !important;
    border: 2px solid #F5CA78 !important;
}

.payment {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    margin-top: 20px;
}
.pay_box{
    display: flex;
}
.pay_box_text{
    font-size: 14px;
    margin-right: 10px
}
.pay_type_btn {
    width: 125px;
    padding: 0.25rem 0.5rem;
    color: rgb(223, 6, 0);
    /* border:1px solid rgb(223, 6, 0); */
    background-color: #fff;
    font-size: .8rem;
    border-radius: 3px;
    margin-right: 10px;
    position: relative;
    transition: all 0.5s;
    text-decoration: none
}

.pay_type_btn:hover {
    transition: all 0.5s;
    color: #FFF !important;
    border-bottom: 4px solid #ff3f3f;
}

.method {
    width: 200px;
    height: 50px;
    background: rgba(246, 242, 235, 0);
    border: 2px solid #E0E0E0;
    border-radius: 4px;
    margin-right: 30px;
    position: relative;
    transition: all 0.5s;
}

.method:hover {
    transition: all 0.5s;
    border: 2px solid #F5CA78
}

.active_pay {
    color: #FFF !important;
    border-bottom: 4px solid #ff3f3f;
}
.hit_pay {
    border: 2px solid #F5CA78 !important;
}

.method_img {
    height: 30px;
    margin-right: 5px;
}
.oder_btn{
    color: #fff;
    background-color: #ed5565;
    border:1px solid #ed5565;
    padding: 0.25rem 0.5rem;
    border-radius: 3px;
    font-size: .8rem;
    text-decoration: none;
}
.submit_btn {
    padding: 15px 120px;
    border-radius: 8px;
    margin-top: 20px;
}
.lq_btn {
    padding: 15px 120px;
    border-radius: 8px;
    margin-top: 40px;
}
.btn_font {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    text-decoration: none;
}

.btn_color {
    transition: all 0.5s;
    background: #B5945B;
}

.btn_color:hover {
    transition: all 0.5s;
    filter: brightness(1.2);
}

/*  */
.content_right {
    display: flex;
    align-items: end;
    height: 100%;
    margin-top: 40px;
}

.beauty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.beauty_img {
    border: 1px solid #CEBFA5;
    border-radius: 8px;
    padding: 8px;
}

.beauty_title {
    font-size: 14px;
    font-family: SimSun;
    font-weight: 400;
    color: #4D4A45;
    margin-bottom: 10px;
}

.time {
    font-size: 14px;
    font-family: SimSun;
    font-weight: 400;
    color: #CF1F1F;
    width: 100%;
    margin-top: 10px;
    text-align: center;
}

/* 月卡 */
.card_item>.row>.col-3 {
    padding-right: 0;
}

.card_index {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 4px;
}

.card_img {
    cursor: pointer;
}

.my_card_box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: start;
}
.my_card_img{
    width: 43.5%;
    margin-right: 10px;
}

.ykfl_box {
    position: relative;
}

.ykfl_content {
    position: absolute;
    z-index: 20;
    padding: 20px 15px;
    height: 100%;
}

.ykfl_title {
    display: flex;
    align-items: flex-end;
    justify-content: start;
}

.ykfl_title h4 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #806437;
    margin: 0;
}

.ykfl_title span {
    font-size: 10px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #806437;
    margin-left: 10px;
}

.yk_num {
    position: relative;
    margin-top: 20px;
}
.yk_tip{
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #806437;
    position: absolute;
    z-index: 20;
    left: 8%;
    bottom: -3px;
}
.ds_bg {
    position: relative;
    top: 0;
    left: 0;
    width: 33%;
}
.yk_title{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #806437;
    margin: 10px 5px 0;
}
.yk_sm{
    display: flex;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #684D21;
    margin: 5% 5px 0;
}
.suoming{
    max-width: 47%;
}
.yk_bg {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
}

.people {
    position: absolute;
    z-index: 10;
    right: 0;
    bottom: 0;
    width: 60%;
}

@media (max-width:1700px) {
    .money:nth-last-child(2) {
        margin-right: 10px;
    }
}

/*  */
@media (max-width:1600px) {
    .yk_tip{
        font-size: 25px;
    }
    /* 充值卡 */
    .card_title {
        font-size: 14px;
    }

    .host_num {
        font-size: 30px;
    }

    .host_num span {
        font-size: 16px;
    }

    .send_title {
        font-size: 12px;
    }

    .money_size {
        font-size: 14px;
    }

    /*  */
    .tip span {
        font-size: 12px;
    }

    .bag_title {}

    .content_left_font {
        font-size: 14px;
    }

    .money_font {
        font-size: 14px;
    }

    /*  */
    .lv_hop {
        font-size: 14px;
    }

    .qq_input {
        height: 40px;
    }

    .btn_font {
        font-size: 14px;
    }

    .method_img {
        height: 25px;
    }

    .submit_btn {
        margin-left: 70px;
    }

    /*  客服*/
    .beauty_ewm {
        width: 100px;
    }
}
@media (max-width:1400px) {
    /* 月卡 */
    .font_color {
        font-size: 14px;
    }
    .ykfl_title h4{
        font-size: 16px;
    }
    .yk_sm{
        margin: 2% 5px 0;
    }
}
@media (max-width:1300px) {
    
    /* 充值卡 */
    .jb_box span {
        left: 80%;
        top: 72%;
        font-size: 12px;
    }

    .card_title {
        font-size: 12px;
    }

    .host_num {
        font-size: 26px;
    }

    .host_num span {
        font-size: 14px;
    }

    .send_title {
        font-size: 12px;
    }

    .money_size {
        font-size: 12px;
    }

    /*  */

    .bag_box {
        padding: 80px 40px 75px;
    }

    .content_left_font {
        font-size: 12px;
    }

    .money_font {
        font-size: 12px;
    }

    .qita_title {
        font-size: 12px;
    }

    .money_qita {
        height: 35px;
    }

    .submit_btn {
        margin-left: 60px;
    }

    .btn_font {
        font-size: 12px;
    }

    .submit_btn {
        padding: 10px 100px;
    }
}
@media (max-width:1200px) {
    /* 月卡 */
    .ykfl_content{
        padding: 10px 15px;
    }
    .yk_num{
        margin-top: 10px;
    }
    .yk_tip {
        font-size: 20px;
    }
    .yk_title {
        font-size: 12px;
    }
    .suoming{
        max-width: 60%;
    }
}
@media (max-width:1100px) {
    .beauty_title {
        font-size: 12px;
        margin-bottom: 5px;
    }

    .time {
        font-size: 12px;
        margin-top: 5px;
    }

    .beauty_ewm {
        width: 80px;
    }
    
}
</style>